// src/Pages/AdminPanel.js
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";

import Sidebar from "../components/AdminPanel/Sidebar";
import Dashboard from "../components/AdminPanel/Dashboard";
import InterviewScheduling from "../components/AdminPanel/InterviewScheduling";
import Calendar from "../components/AdminPanel/Calendar";
import PostJob from "../components/AdminPanel/PostJob";
import PostReservation from "../components/AdminPanel/PostReservation";
import ReservationApplications from "../components/AdminPanel/ReservationApplications"; // 👈 ADD THIS IMPORT
import ManageContributors from "../components/AdminPanel/Managecontributors";
import ManageCertification from "../components/AdminPanel/ManageCertification";
import SiteSettings from "../components/AdminPanel/SiteSettings";
import "../AdminPanel.css";

const AdminPanel = () => {
  const getSectionFromPath = () => {
    const path = window.location.pathname.replace("/admin/", "").replace("/admin", "");
    const validSections = [
      "dashboard", 
      "reservationApplications", // 👈 ADD THIS
      "interview", 
      "calendar", 
      "PostJobb", 
      "reservation",
      "contributors", 
      "certifications", 
      "siteSettings"
    ];
    return validSections.includes(path) ? path : "dashboard";
  };

  const [activeSection, setActiveSection] = useState(getSectionFromPath);

  const [candidates, setCandidates] = useState({
    upcoming: [
      {
        id: 1,
        name: "John Doe",
        email: "john.doe@example.com",
        position: "frontend",
        date: "2024-01-15",
        time: "14:30",
        interviewer: "john",
        status: "scheduled",
        notes: "Senior developer with 5 years experience",
        calendarId: "event-1",
        result: "",
      },
      {
        id: 2,
        name: "Jane Smith",
        email: "jane.smith@example.com",
        position: "backend",
        date: "2024-01-16",
        time: "10:00",
        interviewer: "sarah",
        status: "scheduled",
        notes: "Strong in Node.js and Python",
        calendarId: "event-2",
        result: "",
      },
    ],
    completed: [
      {
        id: 3,
        name: "Mike Johnson",
        email: "mike.j@example.com",
        position: "ux",
        date: "2024-01-10",
        time: "11:00",
        interviewer: "mike",
        status: "completed",
        notes: "Portfolio review needed",
        calendarId: "event-3",
        result: "Selected",
      },
      {
        id: 4,
        name: "Sarah Wilson",
        email: "sarah.w@example.com",
        position: "pm",
        date: "2024-01-08",
        time: "15:45",
        interviewer: "john",
        status: "completed",
        notes: "MBA graduate",
        calendarId: "event-4",
        result: "Rejected",
      },
    ],
  });

  const handleSetActiveSection = (section) => {
    setActiveSection(section);
    window.history.pushState(null, "", `/admin/${section}`);
  };

  // Handle browser back/forward buttons
  useEffect(() => {
    const handlePopState = () => {
      setActiveSection(getSectionFromPath());
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const renderActiveComponent = () => {
    switch (activeSection) {
      case "dashboard":
        return React.createElement(Dashboard, { candidates, setCandidates });

      case "reservationApplications": // 👈 ADD THIS CASE
        return React.createElement(ReservationApplications, null);

      case "interview":
        return React.createElement(InterviewScheduling, { candidates, setCandidates });

      case "calendar":
        return React.createElement(Calendar, { candidates });

      case "PostJobb":
        return React.createElement(PostJob, null);

      case "reservation":
        return React.createElement(PostReservation, null);

      case "contributors":
        return React.createElement(ManageContributors, null);

      case "certifications":
        return React.createElement(ManageCertification, null);

      case "siteSettings":
        return React.createElement(SiteSettings, null);

      default:
        return React.createElement(Dashboard, { candidates, setCandidates });
    }
  };

  return React.createElement(
    "div",
    { className: "admin-container" },

    React.createElement(
      Helmet,
      null,
      React.createElement("title", null, "Admin Panel | VisionBird"),
      React.createElement("meta", {
        name: "description",
        content:
          "VisionBird Admin Panel for managing jobs, candidates, interviews, reservations, and company operations.",
      })
    ),

    React.createElement(Sidebar, {
      activeSection,
      setActiveSection: handleSetActiveSection,
    }),

    React.createElement(
      "main",
      { className: "main-content" },
      renderActiveComponent()
    )
  );
};

export default AdminPanel;